import { render } from "./Art.vue?vue&type=template&id=7612ca87&scoped=true"
import script from "./Art.vue?vue&type=script&lang=js"
export * from "./Art.vue?vue&type=script&lang=js"

import "./Art.vue?vue&type=style&index=0&id=7612ca87&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/caxias-pedal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7612ca87"]])

export default __exports__